import Vue from 'vue'

import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
import '../public/style.css';

import Date from "@/filters/Date.js"
import DateTime from "@/filters/DateTime.js"

import MbInputSelect2 from "@/components/ui/base/MbInputSelect2"
import MbUserAvatarSelect from "@/components/patient-new/MbUserAvatarSelect"
import MbClassAvatarSelect from "@/components/class-new/MbClassAvatarSelect"
import MbContentFind from "@/components/content-find/MbContentFind"

import MbSessionLocalForm from "@/components/session/MbSessionLocalForm"
import MbSessionRemoteForm from "@/components/session/MbSessionRemoteForm"
import MbSessionCalendar from './components/session/MbSessionCalendar.vue';
import MbSessionList from './components/session/MbSessionList.vue';

import MbReportTabs from './components/student/report/MbReportTabs.vue';
import MbReportContents from './components/student/report/MbReportContents.vue';
import MbStudentSubprocessReport from "@/components/student/report/MbStudentSubprocessReport"
import MbStudentTachistoModalReport from "@/components/student/report/MbStudentTachistoModalReport"
import MbStudentReportExportModal from "@/components/student/report/MbStudentReportExportModal"

import MbConfirmModal from "@/components/ui/modal/MbConfirmModal"
import MbChoseTheme from './components/navbar/MbChoseTheme.vue';

import MbSessionForm from './components/session/MbSessionForm.vue';
import MbNoticeWidget from './components/notice/MbNoticeWidget.vue';
import MbGuidaWidget from './components/notice/MbGuidaWidget.vue';
import MbExerciseStats from '@/components/exercise/MbExerciseStats.vue';
import MbBadgeWon from '@/components/badge/MbBadgeWon.vue';
import MbAttestato from '@/components/badge/MbAttestatoView.vue';
import MbStudentList from '@/components/student/MbStudentList.vue';

window.vueComponents = window.vueComponents || {}

Vue.config.productionTip = false

const Widgets = {
  "mb-input-select-2": MbInputSelect2,
  "mb-user-avatar-select": MbUserAvatarSelect,
  'mb-class-avatar-select': MbClassAvatarSelect,
  'mb-content-find': MbContentFind,
  "MbSessionLocalForm": MbSessionLocalForm,
  "MbSessionRemoteForm": MbSessionRemoteForm,
  "MbStudentSubprocessReport": MbStudentSubprocessReport,
  "MbStudentTachistoModalReport": MbStudentTachistoModalReport,
  "MbStudentReportExportModal": MbStudentReportExportModal,
  "MbConfirmModal": MbConfirmModal,
  "MbChoseTheme": MbChoseTheme,
  "mb-session-calendar": MbSessionCalendar,
  "mb-session-list": MbSessionList,
  "mb-notice-widget": MbNoticeWidget,
  "mb-guida-widget": MbGuidaWidget,
  "MbExerciseStats": MbExerciseStats,
  "MbBadgeWon": MbBadgeWon,
  "MbSessionForm": MbSessionForm,
  "MbAttestato": MbAttestato,
  "mb-student-list": MbStudentList,
  "MbReportTabs": MbReportTabs,
  "MbReportContents": MbReportContents
}

const Components = {
};

const Filters = {
  Date,
  DateTime
};

document.addEventListener("DOMContentLoaded", function() {
  Object.keys(Widgets).forEach(name => {
    var els = document.getElementsByClassName(name);
    if (els.length == 0) {
      return;
    }

    Array.prototype.forEach.call(els, el => {
      var ComponentClass = Vue.extend(Widgets[name])
      var instance = new ComponentClass();

      for (let i = 0; i < el.attributes.length; i++) {
        var attrib = el.attributes[i];
        if (instance[attrib.name] != undefined){
          instance[attrib.name] = attrib.value;
        }
      }

      instance.$mount(el)
    });
  });
});

Object.keys(Components).forEach(name => {
  Vue.component(name, Components[name]);

  if (window.Vue){
    window.Vue.component(name, Components[name]);
  }
});

Object.keys(Filters).forEach(name => {
  Vue.filter(name, Filters[name]);

  if (window.Vue){
    window.Vue.filter(name, Filters[name]);
  }
});

window.MbCreateVue = function(widgetName, selector, parameters){
  var els = document.getElementsByClassName(selector);
  if (els.length == 0){
    return;
  }

  var el = els[0];

  var ComponentClass = Vue.extend(Widgets[widgetName])
  var instance = new ComponentClass();
  for(var p in parameters){
    instance[p] = parameters[p];
  }
  instance.$mount()
  el.appendChild(instance.$el)

  window.vueComponents[selector] = instance
  return instance
}